/**
 * Helles Farbschema – ordnet primitive Farb-Tokens semantischen Palette-Slots zu.
 * Wird von lightTheme.ts verwendet, um das MUI-Theme zu erstellen.
 */

import {PaletteOptions} from '@mui/material/styles';

import {blue, brand, neutral, overlay, status, surface} from './customColors';

export const lightPalette: PaletteOptions = {
  // ─── MUI Standard Palette ───────────────────────────────────────────────────

  common: {
    black: neutral.black,
  },
  mode: 'light',
  primary: {
    main: blue.main,
    light: blue.light,
    dark: blue.dark,
  },
  secondary: {
    main: brand.edekaBlue[100],
    light: brand.edekaBlue[50],
    dark: brand.edekaBlue[200],
  },
  warning: {
    main: status.warning.main,
    light: status.warning.light,
    dark: status.warning.dark,
  },
  error: {
    main: status.error.main,
    light: status.error.light,
    dark: status.error.dark,
  },
  success: {
    main: status.success.main,
    light: status.success.light,
    dark: status.success.dark,
    contrastText: neutral.white,
  },
  background: {
    default: surface.light,
  },

  // ─── Custom Palette Extensions ──────────────────────────────────────────────

  misc: {
    main: neutral.greyAlpha59,
    light: neutral.grey50,
    dark: neutral.grey900,
    contrastText: neutral.black,
  },
  pending: {
    main: status.info.main,
    light: status.info.light,
    dark: status.info.dark,
    contrastText: neutral.white,
  },
  loginPage: {
    background: overlay.loginGradient,
    formBoxBackground: overlay.black50,
    topBannerBackground: surface.topBanner,
  },
  app: {
    boxBackground: surface.light,
    boxBorder: surface.light,
    basketBadgeBackground: neutral.navGrey,
  },
  basketPopover: {
    customPopover: neutral.white,
    itemCardBackground: neutral.greyAlpha33,
    deleteBasketText: neutral.black,
    deleteBasketTextHover: neutral.white,
  },
  itemCard: {
    cardBackground: neutral.white,
    imageBoxBackground: neutral.grey50,
  },
  table: {
    background: neutral.greyAlpha33,
  },
  tableRow: {
    background: neutral.white,
  },
  itemView: {
    paper: neutral.white,
  },
  structureMainView: {
    itemBackground: blue.main,
    paper: neutral.white,
  },
  structureTree: {
    customDrawerBackground: surface.light,
  },
  structureTreeItem: {
    secondaryLabelColor: overlay.black60,
  },
  metadataComponent: {
    paper: surface.light,
    tabDisabledText: neutral.greyAlpha33,
  },
  fileNameInfo: {
    navButtonColor: neutral.navGrey,
  },
  fileUploadDialog: {
    background: surface.lightGrey,
    paper: neutral.white,
    tableBackground: neutral.white,
    tableHeaderBackground: surface.lightGreyHeader,
  },
  appBar: {
    background: surface.light,
    typography: neutral.black,
  },
  footer: {
    paper: overlay.black50,
  },
  sideBar: {
    iconColorActive: neutral.black,
    iconColorInactive: neutral.black,
    typography: neutral.black,
    paper: surface.light,
    menuPaper: neutral.white,
  },
  itemStatus: {
    background: neutral.greyAlpha59,
    hoverBackground: neutral.greyHoverLight,
    menuItemBackground: neutral.white,
  },
  derivatePanelGroup: {
    cardBackground: neutral.white,
  },
  userManagement: {
    fontColorSelected: neutral.black,
  },
  customButton: {
    blackColor: neutral.black,
  },
  hero: {
    gradient: `linear-gradient(transparent 50%, ${surface.light})`,
    searchBar: {
      background: surface.light,
      hover: neutral.grey100,
    },
  },
  imageEditor: {
    preview: {
      backgroundColor: neutral.white,
      backgroundImage:
        `linear-gradient(45deg, ${neutral.grey50} 25%, transparent 25%),` +
        `linear-gradient(-45deg, ${neutral.grey50} 25%, transparent 25%),` +
        `linear-gradient(45deg, transparent 75%, ${neutral.grey50} 75%),` +
        `linear-gradient(-45deg, transparent 75%, ${neutral.grey50} 75%)`,
      overlayColor: surface.lightAlpha50,
    },
  },
};
